import { lazy, Suspense } from 'react';
import { redirect, RouteObject } from 'react-router-dom';
import { getUserInfoQuery } from '~/apis/auth';
import LoadingCircularProgress from '~/components/LoadingCircularProgress';
import { isAllowPiracyWebsiteContent } from '~/utils';

const WebsiteContentPage = lazy(() => import('~/pages/WebsiteContent'));

export const WEBSITE_CONTENT_ROUTES: RouteObject[] = [
  {
    index: true,
    loader: async () => {
      const userData = await getUserInfoQuery();

      if (userData?.use_piracy || isAllowPiracyWebsiteContent(userData)) {
        return redirect('detected');
      } else {
        return redirect('flagged');
      }
    },
  },
  {
    path: ':tab/:listingId?',
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <WebsiteContentPage />
      </Suspense>
    ),
  },
];
